export default __webpack_public_path__ + "static/media/top-schedule.f1c910ac.png";